<script setup lang="ts">
  import { type TenantUser } from '@gat-ship/types'
  import { testIds } from '@gat-ship/types'
  import { tenantUserLoadingIds } from '../../composables/useTenantUserDetail'
  import TenantAdminBadge from '../badges/TenantAdminBadge.vue'
  import ScheduledForActivationBadge from '../badges/ScheduledForActivationBadge.vue'
  import ScheduledForDeactivationBadge from '../badges/ScheduledForDeactivationBadge.vue'
  import DeactivatedBadge from '../badges/DeactivatedBadge.vue'
  import {
    Avatar,
    AvatarFallback,
    AvatarImage,
    DataListItem,
    useAppLoading
  } from '@gat-ship/vue-components'
  import { IconLoading } from '@gat-ship/icons'
  defineProps<{
    tenantUser: TenantUser
  }>()

  const { isLoading } = useAppLoading()

  const emit = defineEmits<{
    (e: 'click'): void
  }>()
</script>

<template>
  <DataListItem
    class="@container/list-item-tenant-user"
    :data-testid="testIds.tenantUser.table.cell(tenantUser.userId, 'user')"
    :options="{
      showChevron: true
    }"
    @click:item="emit('click')"
  >
    <div class="flex w-full min-w-0 items-center justify-start gap-2.5">
      <div class="flex min-w-0 shrink grow items-start gap-3.5">
        <Avatar class="size-10">
          <IconLoading
            v-if="isLoading(tenantUserLoadingIds.tenantUser(tenantUser.userId))"
            class="absolute left-1/2 top-1/2 size-5 -translate-x-1/2 -translate-y-1/2 text-white"
            chase
          />
          <AvatarImage v-if="tenantUser.imageUrl" :src="tenantUser.imageUrl" />
          <AvatarFallback>
            {{ tenantUser.fullName.slice(0, 2) }}
          </AvatarFallback>
        </Avatar>
        <div
          class="flex min-w-0 flex-col gap-0.5 overflow-hidden"
          :class="{
            'animate-pulse': isLoading(
              tenantUserLoadingIds.tenantUser(tenantUser.userId)
            )
          }"
        >
          <div class="min-w-0 truncate text-sm font-medium leading-tight">
            {{ tenantUser.fullName }}
          </div>
          <div
            class="text-muted-foreground min-w-0 truncate text-xs leading-tight"
          >
            {{ tenantUser.jobTitle || tenantUser.email }}
          </div>
          <div class="flex items-center justify-start gap-1 pt-2">
            <TenantAdminBadge
              class="@[300px]:flex hidden"
              :tenant-user="tenantUser"
            />
            <ScheduledForActivationBadge
              class="@[500px]:flex hidden shrink"
              :tenant-user="tenantUser"
            />
            <ScheduledForDeactivationBadge
              class="@[500px]:flex hidden shrink"
              :tenant-user="tenantUser"
            />
          </div>
        </div>
      </div>
      <DeactivatedBadge class="ml-auto shrink-0" :tenant-user="tenantUser" />
    </div>
  </DataListItem>
</template>
